import { Component, OnInit, forwardRef, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroup, NG_VALIDATORS } from '@angular/forms';

@Component({
  selector: 'app-dynamic-input',
  templateUrl: './dynamic-input.component.html',
  styleUrls: ['./dynamic-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DynamicInputComponent),
      multi: true
    }
  ]
})
export class DynamicInputComponent implements OnInit, ControlValueAccessor {
  
  @Input() public invalid: string;
  @Input() public myLabel = "";
  @Input() public id = "";
  @Input() public animate: boolean = false;
  @Input() public type;
  @Input() public required: string;
  @Input() public optional: string;
  public mask: string = "T";
  public customPatterns = { 'T': { pattern: new RegExp(/.*/) }, '0': { pattern: new RegExp(/[\d]+/) } };
  @Input() public currency;
  @Input() public percent;
  @Output('focusout') public focusOutEmitter: EventEmitter<any> = new EventEmitter();

  @ViewChild('input', { static: true, read: ElementRef })
  inputElementRef: ElementRef;

  onTouched = () => { };
  onChange = _ => { };

  constructor(private _renderer: Renderer2) { }

  ngOnInit() {
    if (this.type == "date") {
      this.mask = "00/00/0000";
    } else if (this.type == "number") {
      this.mask = "0*";
    } else {
      this.mask = "T*";
    }

    if (this.inputElementRef.nativeElement.value) {
      this.animate = true;
    } else {
      this.animate = false;
    }
  }

  onInputChange() {
    const value = this.inputElementRef.nativeElement.value;
    this.handleLabel();
    this.onChange(value);
  }

  onBlur() {
    this.onTouched();
    this.focusOutEmitter.emit();
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(value: string) {
    this._renderer.setProperty(this.inputElementRef.nativeElement, 'value', value);
  }

  setDisabledState(isDisabled: boolean): void {
    this._renderer.setProperty(this.inputElementRef.nativeElement, 'disabled', isDisabled);
  }

  handleLabel() {
    if (this.inputElementRef.nativeElement.value) {
      this.animate = true;
    } else {
      this.animate = false;
    }
  }

}
